/**
 * Configuration utility for Fantastic Windows theme
 * Provides environment variables from WordPress configuration
 * Replaces process.env usage in browser context
 */

// Create a config object that mimics process.env
const config = {
    // Email Configuration
    get gmailSmtpServer() {
        return window.fantasticWindowsConfig?.gmailSmtpServer || 'smtp.gmail.com';
    },
    get gmailMail() {
        return window.fantasticWindowsConfig?.gmailMail || '';
    },
    get gmailAppPassword() {
        return window.fantasticWindowsConfig?.gmailAppPassword || '';
    },
    get isSendEmail() {
        return window.fantasticWindowsConfig?.isSendEmail || 'false';
    },
    get sendAttachments() {
        return window.fantasticWindowsConfig?.sendAttachments || 'false';
    },
    
    // Contact Information
    get mobileNum() {
        return window.fantasticWindowsConfig?.mobileNum || '1234567890';
    },
    get mobileNum2() {
        return window.fantasticWindowsConfig?.mobileNum2 || '9876543210';
    },
    get customerEmail() {
        return window.fantasticWindowsConfig?.customerEmail || 'fwdf2019@gmail.com';
    },
    get contactUsEmail() {
        return window.fantasticWindowsConfig?.contactUsEmail || 'fwdf2019@gmail.com';
    },
    
    // EmailJS Configuration - DISABLED (using WordPress native emails)
    get emailjsServiceId() {
        return ''; // Disabled - using WordPress native emails
    },
    get emailjsTemplateId() {
        return ''; // Disabled - using WordPress native emails
    },
    get emailjsPublicKey() {
        return ''; // Disabled - using WordPress native emails
    },
    
    // Site Configuration
    get title() {
        return window.fantasticWindowsConfig?.title || 'Fantastic Windows';
    },
    get templateUrl() {
        return window.fantasticWindowsConfig?.templateUrl || '';
    },
    get apiUrl() {
        return window.fantasticWindowsConfig?.apiUrl || '';
    },
    get jsonUrl() {
        return window.fantasticWindowsConfig?.jsonUrl || '';
    }
};

// Check if all required environment variables are defined
const areEnvironmentVariablesDefined = () => {
    const requiredVars = [
        // 'gmailSmtpServer',
        // 'gmailMail', 
        // 'gmailAppPassword',
        'mobileNum',
        'isSendEmail',
        'title',
        'customerEmail',
        'sendAttachments'
    ];
    
    for (const varName of requiredVars) {
        if (!config[varName]) {
            console.log(`Environment variable ${varName} is not defined!`);
            return false;
        }
    }
    
    return true;
};

// Debug function to log all configuration values
const debugConfig = () => {
    console.log('Fantastic Windows Configuration:', config);
    console.log('All variables defined:', areEnvironmentVariablesDefined());
};

// Export for use in other modules
export { config, areEnvironmentVariablesDefined, debugConfig };

// Make config available globally as process.env for backward compatibility
if (typeof window !== 'undefined') {
    window.process = window.process || {};
    window.process.env = config;
}
